
<template>
    <div>
        <div class="col-lg-12">
            <template>
                <tabs fill class="flex-column flex-md-row">
                    <card shadow>
                        <tab-pane 
                            title="Pending Applications"
                            @tab-activated="triggerPendingApplications" 
                        >
                            <span slot="title">
                                <i class="ni ni-books"></i>
                                Pending Applications
                            </span>
                            <!-- import Pending Applications template here --> 
                            <PendingApplications
                                :schoolType="schoolType"
                                :type="type"
                                :visitStatus="'no'"
                                ref="callPendingApplications"
                            />
                        </tab-pane>

                        <tab-pane 
                            title="Verification Visit"
                            v-if="! isAdvisory"
                            @tab-activated="triggerVisitApplications" 
                        >
                            <span slot="title">
                                <i class="ni ni-archive-2"></i>
                                Verification Visit
                            </span>
                            <!-- import Verification Visit template here -->
                            <PendingApplications
                                :schoolType="schoolType"
                                :type="type"
                                :visitStatus="'yes'"
                                ref="callVisitApplications"
                            />
                        </tab-pane>

                        <tab-pane 
                            title="Rejected Applications"
                            @tab-activated="triggerRejectedApplications" 
                        >
                            <span slot="title">
                                <i class="ni ni-badge"></i>
                                Rejected Applications
                            </span>
                            <!-- import Rejected Applications template here -->
                            <RejectedApplications
                                :schoolType="schoolType"
                                :type="type"
                                :status="'rejected'"
                                ref="callRejectedApplications"
                            />
                        </tab-pane>

                        <tab-pane 
                            title="Approved Applications"
                            @tab-activated="triggerApprovedApplications" 
                        >
                            <span slot="title">
                                <i class="ni ni-archive-2"></i>
                                Approved Applications
                            </span>
                            <!-- import Approved Applications template here -->
                            <ApprovedApplications
                                :schoolType="schoolType"
                                :type="type"
                                ref="callApprovedApplications"
                            />
                        </tab-pane>

                        <tab-pane 
                            title="Incomplete Applications"
                            @tab-activated="triggerIncompleteApplications" 
                        >
                            <span slot="title">
                                <i class="ni ni-badge"></i>
                                Incomplete Applications
                            </span>
                            <!-- import Incomplete Applications template here -->
                            <RejectedApplications
                                :schoolType="schoolType"
                                :type="type"
                                :status="'pending'"
                                ref="callIncompleteApplications"
                            />
                        </tab-pane>

                    </card>
                </tabs>
            </template>
        </div>
    </div>
</template>
<script>
    import PendingApplications from './PendingApplications/PendingApplications';
    import RejectedApplications from './RejectedApplications/RejectedApplications';
    import ApprovedApplications from './ApprovedApplications/ApprovedApplications';

    export default {
        name: 'Applications',
        props: ['schoolType', 'type'],
        components: {
            PendingApplications,
            RejectedApplications,
            ApprovedApplications
        },
        data() {
            return {
                code: this.$route.params.code
            }
        },
        computed: {
            isAdvisory() {// check if it is an advisory application
                return (this.code == 'medical-schools-advisory-visit-applications') ||
                    (this.code == 'dental-schools-advisory-visit-applications');
            }
        },
        methods: {
            triggerPendingApplications() {
                if (this.$refs.callPendingApplications && this.$refs.callPendingApplications.loadAplications) {
                    this.$refs.callPendingApplications.loadAplications();
                }
            },
            triggerVisitApplications() {
                if (this.$refs.callVisitApplications && this.$refs.callVisitApplications.loadAplications) {
                    this.$refs.callVisitApplications.loadAplications();
                }
            },
            triggerRejectedApplications() {
                if (this.$refs.callRejectedApplications && this.$refs.callRejectedApplications.loadAplications) {
                    this.$refs.callRejectedApplications.loadAplications();
                }
            },
            triggerApprovedApplications() {
                if (this.$refs.callApprovedApplications && this.$refs.callApprovedApplications.loadAplications) {
                    this.$refs.callApprovedApplications.loadAplications();
                }
            },
            triggerIncompleteApplications() {
                if (this.$refs.callIncompleteApplications && this.$refs.callIncompleteApplications.loadAplications) {
                    this.$refs.callIncompleteApplications.loadAplications();
                }
            },
        }
    };
</script>
<style></style>
